import { useContext } from 'react';

import { AccountContext } from './AccountProvider';

export function useAccountContext() {
  const ctx = useContext(AccountContext);
  if (!ctx) throw new Error('useAccountContext must be used within <AccountProvider>');
  return ctx;
}
